// extracted by mini-css-extract-plugin
export default {"themeToggle":"ThemeToggle_themeToggle__PqZrY","themeIcon":"ThemeToggle_themeIcon__-us7u"};